import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { LoadableFallback } from 'components/Common/LoadableFallback';

const SelectOwnerId = loadable(() => import(/* webpackChunkName: "SelectOwnerId" */ './SelectOwnerId'), {
  fallback: <LoadableFallback visible />,
});

const asyncSelectOwnerId = ({ route }) => (
  <SelectOwnerId route={route} />
);

asyncSelectOwnerId.propTypes = {
  route: PropTypes.object.isRequired,
};

export default asyncSelectOwnerId;
